import {LightBulbIcon} from '@primer/octicons-react'
import {Heading, Link} from '@primer/react'

export function DeepPaginationTip({id, onNarrow}: {id: string; onNarrow: () => void}) {
  return (
    <section className="d-flex flex-justify-center text-center">
      <Heading as="h2" className="f5 text-normal" variant="small" id={id}>
        <LightBulbIcon size={16} className="color-fg-muted mr-2" />
        <strong>ProTip!</strong>{' '}
        <span className="color-fg-muted">
          You can narrow down the results and go further in time using the{' '}
          <Link as="button" onClick={onNarrow} inline>
            created:
          </Link>{' '}
          filter or the other filters available.
        </span>
      </Heading>
    </section>
  )
}
